import React from 'react';
import { View } from 'react-native';

import { Dialog, Heading, Text } from '../../components';
import { InputParlevelQuantity } from '../../components/input';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { PrimaryButton, SecondaryButton } from '../../design/components';

import { createPickListDetailStyles } from './PickListDetail.styles';
import { toNonNegativeNumber } from './PickListDetailHelpers';

// Editor for one product's excluded quantity (open while `summary` is set).
const PickListTubWeightExclusionEditDialog = ({
	summary,
	quantity,
	setQuantity,
	loading,
	onClose,
	onSave,
}) => {
	const styles = useThemedStyles(createPickListDetailStyles);

	return (
		<Dialog
			isOpen={Boolean(summary)}
			onClose={onClose}
		>
			<View style={styles.dialogContent}>
				<Heading
					heading="Edit exclusion"
					subHeading={summary?.productName}
				/>
				<Text style={styles.dialogEditLabel}>
					Excluded quantity
				</Text>
				<View style={styles.dialogInputRow}>
					<InputParlevelQuantity
						product={summary?.product}
						value={quantity}
						onChangeInternal={value => setQuantity(toNonNegativeNumber(value))}
						disabled={loading}
						autoFocus={true}
					/>
				</View>
				<View style={styles.buttonRow}>
					<SecondaryButton
						style={styles.flexButton}
						label="Zero"
						disabled={loading}
						onPress={() => setQuantity(0)}
					/>
					<SecondaryButton
						style={styles.flexButton}
						label="All picked"
						disabled={loading}
						onPress={() => setQuantity(toNonNegativeNumber(summary?.pickedQuantity))}
					/>
				</View>
				<PrimaryButton
					size="compact"
					label="Save exclusion"
					loading={loading}
					onPress={onSave}
				/>
			</View>
		</Dialog>
	);
};

export default PickListTubWeightExclusionEditDialog;
